function titlesDescriptions() {
	
	var desc	= $('meta[name="description"]').attr('content'),
		title	= $('title').text(),
		titleLimit	= 60,
		descLimit	= 145,
		titleCol,
		descCol;
	
	if( title.length > titleLimit || title.length < 1 ) {
		titleCol	= '#c8202f';
	} else {
		titleCol	= '#000000';
	}
	
	if( desc.length > descLimit || desc.length < 1 ) {
		descCol	= '#c8202f';
	} else {
		descCol	= '#000000';
	}
	
	console.log('title – %c' + title + ' [' + title.length + ']', 'color: ' + titleCol);
	if( title.length > titleLimit ) {
		console.log(title.substring(0, titleLimit));
	}
	
	console.log('desc – %c' + desc + ' [' + desc.length + ']', 'color: ' + descCol);
	if( desc.length > descLimit ) {
		console.log(desc.substring(0, descLimit));
	}
	
}

function offendingUrls() {
	
	offUrls	= $( 'a:not( [href$="/"], [href^="mailto:"], [href^="tel:"], [href^="#"], [href*="?"] )' );
	
	console.log('offending urls = ' + offUrls.length );
	
	offUrls.each( function() {
		
		console.log( 'offending url – ' + $(this).attr('href') );
		
	});
	
}

function fourZeroFours() {
	
	$('a:not( [href^="mailto:"], [href^="tel:"] )').each( function() {
		
		var href	= $(this).attr('href');
		
		$.ajax({ 
			cache: false,
		    url: href,
		    success: function (data) {
		        
		        // Not needed
		        
		    },
			error:function (xhr, ajaxOptions, thrownError){
			   
			   if(xhr.status==404) {
			       
			       console.log('404 – ' + href);
			       
			   }
			   
			}
		});
		
		
	});
	
}

function allLinks() {
	
	$('article, .main, [role=main]').find('a:not([href*="www"], [href^="mailto:"], [href^="tel:"])').each( function() {
		
		console.log('article link – ' + $(this).attr('href'));
		
	});
	
}

function altTags() {
	
	$('img[alt=""]').each( function() {
		
		console.log('missing alt – ' + $(this).attr('src'));
		
	});
	
}

$(window).load( function() {
	
//	offendingUrls();
	// fourZeroFours();
	// allLinks();
	// altTags();
	// titlesDescriptions();
	
});